module.exports = __webpack_public_path__ + "img/logo-videomedi.753f8ce5.png";